import dynamic from 'next/dynamic';
import { NavigationMenuProps } from './NavigationMenu.types';

export const NavigationMenu = dynamic<{ model: NavigationMenuProps }>(
  () => import('./NavigationMenu').then(mod => mod.NavigationMenu),
  { ssr: false }
);
